import {AfterViewInit, Component, ViewChild, ViewContainerRef} from "@angular/core";
import {ICellEditorAngularComp} from "ag-grid-angular";
import {DxGridColumn} from "../../../../domain/ui-options/column/dx-grid-column";



// TODO: Нужно реализовать до конца чиловой эдитор, чтоб он мог работать и контролировать ввод целых чисел
// TODO: и числел с плавающей точкой. Информация о конкретном типе данных для данного конкретного инстанса
// TODO: эдитора лежит в типе данных колнки. Под контролем понимается некая маска числа
// TODO: (min, max, число знаков после десятичного разделителя).
// TODO: Не вижу смысла плодить отдельные редакторы под INT, DOUBLE типы данных.


/** Редактор для числовой ячейки */
@Component({
  selector: 'dx-numeric-cell-editor',
  templateUrl: './dx-numeric-cell-editor.component.html',
  styleUrls: ['./dx-numeric-cell-editor.component.css']
})
export class DxNumericCellEditorComponent implements ICellEditorAngularComp, AfterViewInit {
  /**
   * Текущее значение в числовой ячейке.
   * @name value
   * @type {number}
   */
  public value;

  /**
   * Параметры эдитора, предоставляемые AgGrig API.
   * @name _params
   * @type {any}
   */
  private _params: any;

  /**
   * Блокировать редактирование ячейки, если при установленном фокусе на ячеке пользователь попытался начать
   * редактирование вводом не числа. То есть редактирование значения начнется только при вводе чисел.
   * @name _cancelBeforeStart
   * @type {boolean}
   */
  private _cancelBeforeStart: boolean = false;

  /**
   * Прямая ссылка на метаданные колонки, передаваемые через параметры редактора.
   * @name _columnOptions
   * @type {DxGridColumn}
   */
  private _columnOptions: DxGridColumn;

  /** Инстанс инпута. */
  @ViewChild('input', {read: ViewContainerRef, static: true})
  public input;

  constructor() { }


  ngAfterViewInit(): void {
    // Автоустановка фокуса на эдитор.
    setTimeout(() => {
      this.input.element.nativeElement.focus();
    });
  }

  onKeyUp(event): void {
    // if (!this._isKeyPressedNumeric(event)) {
    //   if (event.preventDefault) event.preventDefault();
    // }
  }

  agInit(params: any): void {
    this._params = params;
    if (this._params.value !== 0) this.value = this._params.value;
    this._columnOptions = this._params.columnOptions;
    // only start edit if key pressed is a number, not a letter
    this._cancelBeforeStart = params.charPress && ('1234567890'.indexOf(params.charPress) < 0);
  }

  getValue(): any {
    return parseFloat(this.value);
  }

  isCancelBeforeStart(): boolean {
    return this._cancelBeforeStart;
  }

  getFrameworkComponentInstance(): any {
    return this;
  }

  validate(): boolean {
    return isNaN(this.value);
  }

  /**
   * Отметить редактирование если введенное число больше чем 1,000,000.
   * Просто для демонстрирования возможности.
   */
  isCancelAfterEnd(): boolean {
    return isNaN(this.value);
  }


  private _extractCharCodeFromEvent(event): any {
    event = event || window.event;
    return (typeof event.which == "undefined") ? event.keyCode : event.which;
  }

  private _isCharNumeric(charStr): boolean {
    return !!/\d/.test(charStr);
  }

  private _isKeyPressedNumeric(event): boolean {
    const charCode = this._extractCharCodeFromEvent(event);
    const charStr = event.key ? event.key : String.fromCharCode(charCode);
    return this._isCharNumeric(charStr);
  }
}
